module.exports = __webpack_public_path__ + "media/newstyle/images/logo-estante-color-ff11e00e3d7f757cb49e8fa6880705bb.png";